import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "PersonalAccountCochair__card country-card" }
const _hoisted_2 = { class: "country-card__flex-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "country-card__info" }
const _hoisted_5 = { class: "country-card__title" }
const _hoisted_6 = {
  key: 0,
  class: "country-card__last-meeting"
}
const _hoisted_7 = { class: "country-card__text country-card__text--bold" }
const _hoisted_8 = {
  key: 1,
  class: "country-card__last-meeting"
}
const _hoisted_9 = { class: "country-card__effective-mpk" }
const _hoisted_10 = { class: "country-card__text country-card__subtitle" }
const _hoisted_11 = { class: "country-card__text country-card__text--blue country-card__text--medium" }
const _hoisted_12 = { class: "country-card__trade" }
const _hoisted_13 = { class: "country-card__subtitle country-card__text country-card__text--nowrap" }
const _hoisted_14 = { class: "country-card__text country-card__text--blue country-card__text--medium" }
const _hoisted_15 = { class: "country-card__position" }
const _hoisted_16 = { class: "country-card__text country-card__text--small country-card__text--nowrap" }
const _hoisted_17 = { class: "country-card__flex-container" }
const _hoisted_18 = {
  key: 0,
  class: "country-card__divider"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DynamicIndicator = _resolveComponent("DynamicIndicator")!
  const _component_ArrowDynamic = _resolveComponent("ArrowDynamic")!
  const _component_PersonCard = _resolveComponent("PersonCard")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "country-card__flag",
        src: _ctx.country.country.picture || '',
        alt: "Флаг страны"
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.country.country.name), 1),
        (_ctx.country.mpk)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[0] || (_cache[0] = _createElementVNode("h4", { class: "country-card__text country-card__subtitle" }, "Последнее заседание МПК:", -1)),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.country.mpk.event || 'Заседания не проводились'), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("h4", { class: "country-card__text country-card__subtitle" }, "МПК отсутствует", -1)
            ]))])),
        _withDirectives(_createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, [
            _cache[2] || (_cache[2] = _createTextVNode(" Эффективность МПК: ", -1)),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.country.summaryRatingPosition) + " место ", 1)
          ])
        ], 512), [
          [_vShow, _ctx.country.summaryRatingPosition]
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, [
            _cache[3] || (_cache[3] = _createTextVNode(" Товарооборот: ", -1)),
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.getSummaryTotalValue) + " млн $ ", 1)
          ]),
          _createVNode(_component_DynamicIndicator, {
            value: _ctx.country.summary.totalValuePreviousPercent,
            oldValue: 0,
            postfix: "%"
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_ArrowDynamic, {
              value: _ctx.country.summary.diffPlaceInRussianTradeTurnover
            }, null, 8, ["value"]),
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.country.summary.placeInRussianTradeTurnover) + " место", 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      (_ctx.country.mpk && _ctx.country.mpk.participant)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18))
        : _createCommentVNode("", true),
      (_ctx.country.mpk && _ctx.country.mpk.participant)
        ? (_openBlock(), _createBlock(_component_PersonCard, {
            key: 1,
            className: "country-card__personal-card",
            position: _ctx.country.mpk.participant?.position,
            name: _ctx.country.mpk.participant?.name,
            avatar: _ctx.country.mpk.participant?.picture,
            flag: _ctx.country.mpk.participant?.country.picture
          }, null, 8, ["position", "name", "avatar", "flag"]))
        : _createCommentVNode("", true)
    ])
  ]))
}